import { WorkOrderStatus } from "@myapp/contract";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const STATUS_LABELS: Record<WorkOrderStatus, string> = {
  NOT_PLANNED: "Nicht geplant",
  PLANNED: "Geplant",
  FOLLOW_UP_REQUIRED_1: "Nachfolge erforderlich 1",
  FOLLOW_UP_PLANNED_1: "Nachfolge geplant 1",
  FOLLOW_UP_REQUIRED_2: "Nachfolge erforderlich 2",
  FOLLOW_UP_PLANNED_2: "Nachfolge geplant 2",
  COMPLETED: "Abgeschlossen",
  COMPLETED_FOLLOW_UP_1: "Abgeschlossen (Nachfolge 1)",
  COMPLETED_FOLLOW_UP_2: "Abgeschlossen (Nachfolge 2)",
  NOT_REACHED: "Nicht erreicht",
  CANCELLED: "Gelöscht",
};

export const getWorkOrderStatusLabel = (status: WorkOrderStatus): string =>
  STATUS_LABELS[status];

const STATUS_COLORS: Record<WorkOrderStatus, string> = {
  NOT_PLANNED: "#9CA3AF",
  PLANNED: "#2EB5D9",
  FOLLOW_UP_REQUIRED_1: "#ED9E42",
  FOLLOW_UP_PLANNED_1: "#2EB5D9",
  FOLLOW_UP_REQUIRED_2: "#ED9E42",
  FOLLOW_UP_PLANNED_2: "#2EB5D9",
  COMPLETED: "#3BC67D",
  COMPLETED_FOLLOW_UP_1: "#3BC67D",
  COMPLETED_FOLLOW_UP_2: "#3BC67D",
  // Red: the tenant is blocking the Auftrag and it escalates. Gray for „Gelöscht": closed, not done.
  NOT_REACHED: "#D64541",
  CANCELLED: "#6B7280",
};

export const getWorkOrderStatusColor = (status: WorkOrderStatus): string =>
  STATUS_COLORS[status];

export const workOrderStatusOptions: ISelectOption[] = (
  Object.keys(STATUS_LABELS) as WorkOrderStatus[]
).map((status) => ({ value: status, label: STATUS_LABELS[status] }));
